// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/about/about.less
 ** module id = 40
 ** module chunks = 0
 **/